import { useState } from 'react';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_GUARANTEE_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import styles from './SpotahomeGuaranteeModal.module.scss';

const SpotahomeGuaranteeModal = () => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  const handleOpen = ({ title: titlePayload, body: bodyPayload }) => {
    setTitle(titlePayload);
    setBody(bodyPayload);
  };

  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_GUARANTEE_MODAL,
    onOpen: handleOpen
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      className={styles['spotahome-guarantee-modal']}
    >
      <ModalHeader onRequestClose={handleModalClose} label={title} />
      <ModalBody className={styles['spotahome-guarantee-modal__body']}>
        <p>{body}</p>
      </ModalBody>
    </Modal>
  ) : null;
};

export default SpotahomeGuaranteeModal;
